"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyBaseDiscount = void 0;
function makeEmptyBaseDiscount() {
    return {
        id: 0,
        rate: 0,
        maxQuotas: 0,
        total: 0,
    };
}
exports.makeEmptyBaseDiscount = makeEmptyBaseDiscount;
//# sourceMappingURL=BaseDiscount.js.map